import React from "react";
import "./index.css";

const Content = ({ children }: { children?: React.ReactNode }) => {
  return <main className="content">{children}</main>;
};

export default Content;
